<!--  -->
<template>
	<div>
		<div v-if="localStorage.orderLineType == 'insite'">
			<div class="fail">{{$t('OrderDetail.order1')}}</div>
		    <van-button @click="$router.push('/OrderDetail/'+sessionStorage.actOrderId)" class="btn" block>{{$t('OrderDetail.returnOrder')}}</van-button>
		</div>
		<div v-if="localStorage.orderLineType == 'takeAway'">
			<div class="success">{{$t('OrderDetail.order1')}}</div>
			<van-button @click="continueOrder()" class="btn" block>{{$t('OrderDetail.newOrder')}}</van-button>
		</div>	        
	</div>
</template>

<script>
export default {
	data () {
        return {

        };
    },
    created(){

    },
    methods: {
    	continueOrder(){
    		this.$axios({
                method:'get',
                url:this.$build+'/api/shopcart/create',
            }).then(res=>{
                console.log(res)
                if(res.data.status==200){
                    localStorage.setItem('onlyCode',res.data.code)
                    var vm = this;
                    // 跳转到菜品页面
                    setTimeout(()=>{
                        vm.$router.push('/TakeDishes')
                    },500)
                }else{
                    for (var item in res.data.error) {
                        this.$toast({
                            type:'fail',
                            message:res.data.error[item],
                        });
                    }
                }
            }).catch(err => {
                this.$toast({
                    type:'fail',
                    message:this.$t('common.message'),
                });
            });
    	},
    }
}

</script>
<style scoped>
    .fail{
		height: 200px;
		text-align: center;
		line-height: 200px;
		font-size: 30px;
		color: #84D48D;
		font-weight: bold;
		background: #fff;
	}
	.btn{
		background: #2f75f4;
		color: #fff;
		margin:10px auto;
		width: 50%;
		border-radius: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/Fail.vue